(() => {
  const host = document.querySelector('[data-bondage-picks]');
  if (!host || host.dataset.loaded) return;
  host.dataset.loaded = 'true';
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 12000);
  fetch(host.dataset.url, { signal: controller.signal, credentials: 'same-origin' })
    .then(response => { if (!response.ok) throw new Error('Products unavailable'); return response.text(); })
    .then(html => {
      const document = new DOMParser().parseFromString(html, 'text/html');
      const cards = [...document.querySelectorAll('[data-bondage-pick]')];
      if (!cards.length) throw new Error('No available picks');
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      const track = host.querySelector('.dut-bondage__products');
      track.replaceChildren(...cards.slice(0, 5));
      host.querySelectorAll('[data-picks-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.picksDirection);
          const max = track.scrollWidth - track.clientWidth;
          const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          const atStart = track.scrollLeft <= 2;
          const atEnd = track.scrollLeft >= max - 2;
          const left = direction > 0 ? (atEnd ? 0 : Math.min(max, track.scrollLeft + step))
            : (atStart ? max : Math.max(0, track.scrollLeft - step));
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
      });
    })
    .catch(() => { host.hidden = true; })
    .finally(() => clearTimeout(timer));
})();
